import React, { Fragment, useEffect, useState } from 'react';
import { Button, Dropdown, Menu, Typography } from "antd";
import ApiService from "../../../services/ApiService";
import { useSelector } from "react-redux";
import { API_BASE_URL } from "../../../configs/AppConfig";

import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Text } = Typography;

export default function CerfaButton() {
    const [data, setData] = useState([]);
    const org = useSelector(state => state.auth.org);

    useEffect(() => {
        getData();
    }, []);

    async function getData() {
        const res = await ApiService.get("/auth/assoc");
        if (res.success) {
            setData(res.data);
        }
    }

    if (data.length === 0) {
        return (
            <Button
                target="_blank"
                href={API_BASE_URL + "/cerfas/exemple/" + org.id}
                type="primary"
            >
                <Trans>Exemple de Cerfa</Trans>
            </Button>
        );
    }

    return (
        <Fragment>
            <Dropdown
                overlay={
                    <Menu
                        items={data.map((item, index) => {
                            let id = item.value;
                            if (id === "MAIN") {
                                id = org.id;
                            }
                            return {
                                key: index,
                                label: (
                                    <a
                                        target="_blank"
                                        href={API_BASE_URL + "/cerfas/exemple/" + id}
                                        rel="noreferrer"
                                    >
                                        <Text>{item.label}</Text>
                                    </a>
                                ),
                            };
                        })}
                    />
                }
                trigger={['click']}
            >
                <Button type="primary">
                    <Trans>Exemple de Cerfa</Trans>
                </Button>
            </Dropdown>
        </Fragment>
    );
}
